import type {FetchVacanciesQuery, Vacancies} from '../../http';
import {fetchVacancies} from '../../http';
import {useInfiniteQuery, UseInfiniteQueryOptions} from 'react-query';

type InfiniteVacanciesQuery = Omit<FetchVacanciesQuery, 'page'>;

const defaultQuery: InfiniteVacanciesQuery = {};

export function useInfiniteFetchVacancies(
	query?: InfiniteVacanciesQuery,
	options?: UseInfiniteQueryOptions<Vacancies>,
) {
	const q = query ?? defaultQuery;

	return useInfiniteQuery<Vacancies>({
		queryKey: ['vacancies', 'infinite', q],
		queryFn: async ({pageParam = 1, signal}) => {
			const {data} = await fetchVacancies({...q, page: pageParam}, signal);

			return data;
		},
		getNextPageParam: (lastPage) => {
			const currentPage = lastPage.meta?.current ?? 1;
			const lastPageNumber = lastPage.meta?.last ?? currentPage;

			if (currentPage >= lastPageNumber) return undefined;

			return currentPage + 1;
		},
		...options,
	});
}
